import React, { useEffect, useState, useContext } from "react";
// import Select from "react-select";
import { Select } from 'antd';
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { TableDataContext } from "../../Contexts/TableDataContext";

/* The `options` constant is an array of objects that represents the available options for the
financial filter component. Each object in the array has the following properties: */
const options = [
  { value: "revenue", label: "Revenue", min: "", max: "", filterLable: "Rev" },
  { value: "ebitda", label: "EBITDA", min: "", max: "", filterLable: "EBITDA" },
  { value: "net_profit", label: "Net Profit", min: "", max: "", filterLable: "N_Profit" },
  { value: "total_debt", label: "Total Debt", min: "", max: "", filterLable: "Total_Debt" },
  { value: "net_worth", label: "Networth", min: "", max: "", filterLable: "Networth" },
  { value: "capital_employed", label: "Capital Employed", min: "", max: "", filterLable: "Capital_Employed" }
];
/**
 * The FinancialsBasedFilter component is a JavaScript function that renders a filter component for
 * financial data based on selected options and values.
 * @returns The FinancialsBasedFilter component is returning a JSX element.
 */
const FinancialsBasedFilter = ({
  open,
  accordionClick,
  FinancialYear,
  setFinancialYear,
  FinancialOptions,
  setFinancialOptions,
  FinancialAndOr,
  setFinancialAndOr,
  customPathname,
  currencyType,
  setCurrencyType,
  label = "Financial Based",
  isPopupOpen,
  setIsPopupOpen
}) => {
  const { refineSearchFilters } = useContext(PeFilterContext);
  const { currency } = useContext(TableDataContext);
  const [finOptions, setFinOptions] = useState(options);


  /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
  `useEffect` hook is used to update the state variables `financialYear`, `financialOptions`,
  `financialCurrencyType`, and `finAndOr` based on the values stored in the `refineSearchFilters`
  object. */
  useEffect(() => {
    const financialYear = refineSearchFilters[customPathname]?.financialYear?.at(0)?.value;
    const financialOptions = refineSearchFilters[customPathname]?.financialPercentage?.map(option => option.value);
    const financialCurrencyType = refineSearchFilters[customPathname]?.financialCurrencyType?.at(0)?.value ?? true
    const finAndOr = refineSearchFilters[customPathname]?.financialOperator?.at(0)?.value ?? "or";
    setFinancialYear(financialYear ?? "any")
    setCurrencyType(financialCurrencyType)
    setFinancialOptions(financialOptions ?? []);
    setFinancialAndOr(finAndOr);
  }, [customPathname, refineSearchFilters, setCurrencyType, setFinancialAndOr, setFinancialOptions, setFinancialYear])

  /**
   * The function `onFinancialYearChange` sets the value of `financialYear` to the provided `value`.
   * @param value - The value parameter represents the new financial year that is being selected.
   */
  const onFinancialYearChange = (value) => {
    // setFinancialYear(prev => prev === value ? null : value)
    setFinancialYear(value)
    // setGrowthOptions([])
  }

  /**
   * The function `onFinancialOptionChange` updates the financial options based on the selected option.
   * @param e - The "e" parameter is an event object that represents the event that triggered the
   * change. It can be used to access information about the event, such as the target element that
   * triggered the change.
   * @param selected - The "selected" parameter is the value that has been selected or changed in the
   * financial options.
   */
  const onFinancialOptionChange = (e, selected) => {
    setFinancialOptions(selected)
  }


  /**
   * The function `onOptionsYearChange` is used to handle changes in financial options for a specific
   * year.
   * @param index - The index parameter represents the index of the financial option in the
   * FinancialOptions array. It is used to identify which option is being changed.
   * @param optionKey - The `optionKey` parameter represents the key of the option being changed. It
   * can have two possible values: "min" or "max".
   * @param value - The value parameter represents the new value that is being entered or selected for
   * the financial option.
   * @param key - The `key` parameter is a string that represents the unique identifier of the
   * financial option.
   */
  const onOptionsYearChange = (index, optionKey, value, key) => {
    const validNumber = new RegExp(/^\d*\.?\d*$/);
    let processedValue = "";
    if (validNumber.test(value)) {
      processedValue = value;
    } else {
      processedValue = optionKey === "min" ? FinancialOptions[index].min : FinancialOptions[index].max;
    }
    // const  = value?.replace(/[^\d\.]*/g, '')
    setFinancialOptions(prev => {
      let temp = [...prev];
      if (optionKey === "min") {
        temp[index].min = processedValue
      } else if (optionKey === "max") {
        temp[index].max = processedValue
      }
      return temp;
    })
    // setFinancialOptions(prev => {
    //   let temp = [...prev];
    //   const optionIndex = temp.findIndex(option => option.value === key)
    //   if (optionIndex !== -1) {
    //     if (optionKey === "min") {
    //       temp[optionIndex].min = processedValue === "" ? "" : Number(processedValue)
    //     } else if (optionKey === "max") {
    //       temp[optionIndex].max = processedValue === "" ? "" : Number(processedValue)
    //     }
    //   }
    //   return temp;
    // })
  }

  /**
   * The handleCurrencyChange function toggles the currency type.
   */
  const handleCurrencyChange = () => {
    setCurrencyType(prev => !prev)
  }

  const getSelectedCount = () => {
    return FinancialOptions?.filter(option => option.min !== "" && option.max !== "").length || 0;
  };

  console.log('FinancialOptions-12', currencyType);

  return (
    <div className="px-4 bg-white">
      <h3 className="text-lg font-semibold mb-4 text-[#333333] flex items-center justify-between">
        <span>{label}</span>
        {getSelectedCount() > 0 && (
          <span className="bg-[#BC8B20] text-white text-xs rounded-full px-2 py-1 min-w-[20px] text-center">
            {getSelectedCount()}
          </span>
        )}
      </h3>

      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <input
              className="cursor-pointer mr-2"
              type="checkbox"
              id="unit"
              checked={currencyType}
              onChange={handleCurrencyChange}
            />
            <label htmlFor="unit" className="text-sm cursor-pointer whitespace-nowrap">
              {currency === 'USD' ? 'In $M' : 'In Cr'}
            </label>
          </div>


          <div className="flex items-center gap-4">
            <label className="font-semibold text-sm text-[#333333]">Year:</label>
            <div className="flex items-center">
              <input
                type="radio"
                className="cursor-pointer mr-2"
                value="any"
                checked={FinancialYear === "any"}
                onChange={() => onFinancialYearChange('any')}
                id="any"
              />
              <label htmlFor="any" className="text-sm cursor-pointer whitespace-nowrap">
                Any of
              </label>
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                value="all"
                className="cursor-pointer mr-2"
                checked={FinancialYear === "all"}
                onChange={() => onFinancialYearChange('all')}
                id="all"
              />
              <label htmlFor="all" className="text-sm cursor-pointer whitespace-nowrap">
                Across All
              </label>
            </div>
          </div>
        </div>

        <div>
          <Select
            mode="multiple"
            showSearch
            options={finOptions}
            optionFilterProp='label'
            value={FinancialOptions}
            onChange={onFinancialOptionChange}
            placeholder="Select financial metrics"
            style={{
              width: '100%',
              border: '1px solid #BC8B20',
              borderRadius: '4px',
              background: '#ffffff',
              maxHeight: '60px',
              overflowY: "auto"
            }}
            bordered={false}
          />
        </div>

        {FinancialOptions.length > 0 && (
          <div>
            <div className="grid grid-cols-3 gap-3 mb-3">
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333]">Fields</label>
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333] text-center">Greater than</label>
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333] text-center">Less than</label>
            </div>

            {FinancialOptions.map((option, i) => (
              <div key={option.value} className="grid grid-cols-3 gap-3 items-center mb-2">
                <div className="text-sm text-[#333333] font-sans_book_body">{option.label}</div>
                <div>
                  <input
                    className="border border-gray-300 rounded p-2 w-full text-sm"
                    type="text"
                    required={option.max !== ""}
                    placeholder="Min"
                    value={option.min}
                    onChange={(e) => onOptionsYearChange(i, "min", e.target.value, option.value)}
                  />
                </div>
                <div>
                  <input
                    className="border border-gray-300 rounded p-2 w-full text-sm"
                    type="text"
                    required={option.min !== ""}
                    placeholder="Max"
                    value={option.max}
                    onChange={(e) => onOptionsYearChange(i, "max", e.target.value, option.value)}
                  />
                </div>
              </div>
            ))}

            <hr className="my-4" />

            <div>
              <ToggleButton
                value={FinancialAndOr === "or"}
                onLabel="AND"
                offLabel="OR"
                onToggle={(value) => setFinancialAndOr(value)}
                from="cfsRefineSearch"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default FinancialsBasedFilter;

